import Vue from 'vue';
import Router from 'vue-router';

Vue.use(Router);

export default new Router({
    routes: [

        {
            path: '/',
            component: () => import( /* webpackChunkName: "home" */ '../components/common/Home.vue'),
            meta: {
                title: ''
            },
            children: [
                {
                    path: '/FeeManage',
                    component: () => import('../components/page/fee/FeeManage.vue'),
                    meta: {
                        title: "费用管理",
                        roles: ['FeeManage']
                    }
                },
                {
                    path: '/MailRecord',
                    component: () => import('../components/page/fee/MailRecord.vue'),
                    meta: {
                        title: "邮件记录",
                        roles: ['MailRecord']
                    }
                },
                {
                    path: '/MainProcessManage',
                    component: () => import('../components/page/MainProcess/MainProcessManage.vue'),
                    meta: {
                        title: "主流程管理",
                        roles: ['MainProcessManage']
                    }
                },
                {
                    path: '/ProcessCancelLogManage',
                    component: () => import('../components/page/MainProcess/ProcessCancelLogManage.vue'),
                    meta: {
                        title: "作废日志",
                        roles: ['ProcessCancelLogManage']
                    }
                },
                {
                    path: '/SubProcessManage',
                    component: () => import('../components/page/SubProcess/SubProcessManage.vue'),
                    meta: {
                        title: '子流程管理',
                        roles: ['SubProcessManage']
                    }
                },
                {
                    path: '/VoucherReverse',
                    component: () => import('../components/page/Reverse/VoucherReverse.vue'),
                    meta: {
                        title: 'SAP凭证反写',
                        roles: ['VoucherReverse']
                    }
                },
                {
                    path: '/InvoiceAuthentication',
                    component: () => import('../components/page/Auth/InvoiceAuthentication.vue'),
                    meta: {
                        title: '发票认证',
                        roles: ['InvoiceAuthentication']
                    }
                },
                {
                    path: '/SupplierManage',
                    component: () => import('../components/page/MasterData/SupplierManage.vue'),
                    meta: {
                        title: '供应商主数据',
                        roles: ['SupplierManage']
                    }
                },
                {
                    path: '/POManage',
                    component: () => import('../components/page/MasterData/POManage.vue'),
                    meta: {
                        title: 'PO主数据',
                        roles: ['POManage']
                    }
                },
                {
                    path: '/Companysettings',
                    component: () => import('../components/page/BasicSettings/Companysettings.vue'),
                    meta: {
                        title: '公司设置',
                        roles: ['Companysettings']
                    }
                },
                {
                    path: '/Userpermissionsettings',
                    component: () => import('../components/page/BasicSettings/Userpermissionsettings.vue'),
                    meta: {
                        title: '用户权限设置',
                        roles: ['Userpermissionsettings']
                    }
                },
                {
                    path: '/Member',
                    component: () => import('../components/page/BasicSettings/Member.vue'),
                    meta: {
                        title: '人员管理',
                        roles: ['Member']
                    }
                }
            ]
        },
        {
            path: '/login',
            component: () => import( /* webpackChunkName: "login" */ '../components/page/Login.vue'),
            meta: {
                title: '登录'
            }
        },
        {
            path: '*',
            redirect: '/404'
        }
    ]
});
